module.exports = __webpack_public_path__ + "media/images/application2/AppMfaIdentityVerification__dl__item--2-7a13d5ef9c6cd5dd2f38be3e4c9b29bd.svg";